var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 7.55534C18.6667 5.78723 17.9643 4.09154 16.714 2.84129C15.4638 1.59105 13.7681 0.888672 12 0.888672C10.2319 0.888672 8.5362 1.59105 7.28596 2.84129C6.03571 4.09154 5.33333 5.78723 5.33333 7.55534C5.33333 15.3331 2 17.5553 2 17.5553H22C22 17.5553 18.6667 15.3331 18.6667 7.55534Z",
    stroke: "#0062AA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9226 22C13.7272 22.3368 13.4468 22.6163 13.1095 22.8106C12.7721 23.0049 12.3897 23.1072 12.0003 23.1072C11.611 23.1072 11.2286 23.0049 10.8912 22.8106C10.5539 22.6163 10.2735 22.3368 10.0781 22",
    stroke: "#0062AA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.995ef56015482c26cd2ef8a376503937.svg";
export { ForwardRef as ReactComponent };